import { useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'
import { LogErrors } from './../../../../utilities/LogErrors'
import { useLanguage } from './../../../../utilities/LanguageContext'


import { GetExam, GetInstrumentName as BLGetInstrumentName, GetBlockName as BLGetBlockName, GetEvaluationData as BLGetEvaluationData } from './../../../../utilities/BL/Student/Instruments'
import { DeleteSessionInfo, Logout, ValidateSession } from './../../../../utilities/BL/Sessions'

import { GoToBack } from './../../../Common/GoToBack'
import { Disabled } from './../../Common/Disabled'
import { useFloatMessage, MESSAGE_TYPE } from './../../../Providers/FloatMessage'
import { GetEvaluationMethod } from './../../../../utilities/BL/Navigation'


//Agregar multiidioma


const Exam = ({ session, instrument, isInstrumentEnabled }) => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()
    const { showMessage } = useFloatMessage()

    const [examName, setExamName] = useState('')
    const [blockName, setBlockName] = useState('')
    const [evaluation, setEvaluation] = useState(null)
    const [isButtonLoading, setIsButtonLoading] = useState(false)
    const [loginView, setLoginView] = useState(false)

    const [remainingTime, setRemainingTime] = useState(null)
    
    const evaluationMethods = {
        DESKTOP: 1,
        THEORIST: 2,
        WEBAPPS: 3
    }


    const GoToExam = async () => {
        try {
            //let nextStep = false
            let completeURL = ''
            //let isExternalMethod = false

            setIsButtonLoading(true)

            const tmpSession = await ValidateSession()
            
            if (tmpSession.success) {
                if (tmpSession.data.user.userStatus === 2) {
                    const instrument = tmpSession?.data?.navigation?.instrument
                    
                    if (instrument) {
                        const responseEvaluationMethod = await GetEvaluationMethod(instrument)
                        
                        if (responseEvaluationMethod.success) {
                            const method = responseEvaluationMethod?.data?.method
                            
                            if (method === evaluationMethods.THEORIST || method === evaluationMethods.WEBAPPS) {
                                const urlToSend = responseEvaluationMethod?.data?.url
        
                                if (!urlToSend) {
                                    //console.log('No fue posible enviar al examen solicitado') 
                                    showMessage({
                                        type: MESSAGE_TYPE.BAD,
                                        text: 'No ha sido posible iniciar la evaluación solicitada. Inténtalo nuevamente o inténtalo más tarde'
                                    })
                                    return
                                }
        
                                if (urlToSend === '') {
                                    //console.log('No fue posible enviar al examen solicitado')
                                    showMessage({
                                        type: MESSAGE_TYPE.BAD,
                                        text: 'No ha sido posible iniciar la evaluación solicitada. Inténtalo nuevamente o inténtalo más tarde'
                                    })
                                    return
                                }
        
                                // const responseLogout = await Logout()
                
                                // if (responseLogout.success) {
                                    // En vez de cerrar la sesión con el Token, cierro la sesión borrando los datos correspondientes del sessionStorage
                                    // Así detectará que no hay info y lo enviará al Login para iniciar sesión
                                    await DeleteSessionInfo()

                                    window.location.href = urlToSend
                                    return
                                // } else {
                                //     // Aunque no se le haya podido cerrar la sesión, lo envíamos a la web ya que como tal, no está mal o no es un error crítico
                                //     window.location.href = urlToSend
                                //     return
                                // }

                            } else if (method === evaluationMethods.DESKTOP) {
                                const response = await GetExam(session)

                                if (response.success) {
                                    //Iniciar sesión
                                    setLoginView(true)
                                    //await Logout(tmpSession.data.token)
                                    await Logout()
                                    window.location.href = 'ztudia://' + response.data.token
                                } else {
                                    //console.log(response.message)
                                    //<p className='Exams-Container-Notes'>{translate('labels.viewer.exam.note')}</p>
                                    //setErrorMessage(response.message)

                                    showMessage({
                                        type: MESSAGE_TYPE.BAD,
                                        text: response.message
                                    })
                                    return
                                }
                            
                            } else {
                                //isExternalMethod = false
                                showMessage({
                                    type: MESSAGE_TYPE.BAD,
                                    text: 'No ha sido posible obtener la evaluación deseada. Inténtalo nuevamente o inténtalo más tarde'
                                })
                                return
                            }
                        } else {
                            //console.log('No fue posible obtener el examen solicitado')
                            showMessage({
                                type: MESSAGE_TYPE.BAD,
                                text: 'No ha sido posible obtener la evaluación solicitada. Inténtalo nuevamente o inténtalo más tarde'
                            })
                            return
                        }
                    } else {
                        showMessage({
                            type: MESSAGE_TYPE.BAD,
                            text: 'No ha sido posible obtener la información de tu evaluación. Inténtalo nuevamente o inténtalo más tarde'
                        })
                        return
                    }
                } else {
                    navigate('/confirm')
                }
            } else {
                navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
            }
        } catch (error) {
            await LogErrors('GoToExam - Viewer Exam', error)
        }
    }

    const FormatRemainingTime = (totalSeconds) => {
        try {
            if (totalSeconds == null || isNaN(totalSeconds) || totalSeconds < 0) return ''
    
            // Horas, minutos y segundos
            const hours = Math.floor(totalSeconds / 3600)
            const minutes = Math.floor((totalSeconds % 3600) / 60)
            const seconds = totalSeconds % 60
    
            // Si es menos de 60 segundos
            if (totalSeconds < 60) {
                return `${seconds} segundos`
            }
    
            // Si es menos de 1 hora
            if (totalSeconds < 3600) {
                const mm = String(minutes).padStart(2, '0')
                const ss = String(seconds).padStart(2, '0')
                return `${mm}:${ss} minutos`
            }
    
            // Si es 1 hora o más
            const hh = String(hours).padStart(2, '0')
            const mm = String(minutes).padStart(2, '0')
            const ss = String(seconds).padStart(2, '0')
    
            return `${hh}:${mm}:${ss} horas`
        } catch (error) {
            return null
        }
    }

    const GetEvaluationData = async () => {
        try {
            const response = await BLGetEvaluationData()
            
            if (response.success) {
                setEvaluation(response.data)
                setRemainingTime(await FormatRemainingTime(response.data.time))
            } else {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
            }
        } catch (error) {
            await LogErrors('GetEvaluationData - Viewer Exam', error)
        }
    }

    const GetInstrumentName = async () => {
        try {
            const response = await BLGetInstrumentName(session)

            if (response.success) {
                setExamName(response.data)
            } else {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
            }
        } catch (error) {
            await LogErrors('GetInstrumentName - Viewer Exam', error)
        }
    }

    const GetBlockName = async () => {
        try {
            const response = await BLGetBlockName(session, instrument)

            if (response.success) {
                setBlockName(response.data)
            } else {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
            }
        } catch (error) {
            await LogErrors('GetBlockName - Viewer Exam', error)
        }
    }

    const GoToLogin = async () => {
        try {
            navigate('/')
        } catch (error) {
            await LogErrors('GoToLogin - Viewer Exam', error)
        }
    }

    const LoadPage = async () => {
        try {
            document.body.classList.add('BodyComplete')

            
            await GetInstrumentName()
            await GetBlockName()
            await GetEvaluationData()
        } catch (error) {
            await LogErrors('LoadPage - Viewer Exam', error)
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])

    
    return (
        <>
            {isInstrumentEnabled === true ? (
                <main className='container Container-FullHeight Exams'>
                    {loginView ? (
                        <>
                            {(evaluation && evaluation?.questions && evaluation?.time) && (
                                <div className="Exams__SessionFinished">
                                    <p className='Exams__SessionFinished--Title'>Iniciando evaluación...</p>
                                    <p className='Exams__SessionFinished--Text'>Te vamos a evaluar{evaluation?.questions && (` ${evaluation.questions} preguntas`)}{remainingTime && (` en ${remainingTime}`)}.</p>
                                    <p className='Exams__SessionFinished--Text'>La calificación mínima aprobatoria es de 800 puntos de 1,000 puntos posibles.</p>
                                </div>
                            )}

                            <div className="Exams__SessionFinished">
                                <p className='Exams__SessionFinished--Title'>Además...</p>
                                <p className='Exams__SessionFinished--Text'>Se ha cerrado tu sesión para que puedas presentar tu evaluación.</p>
                                <p className='Exams__SessionFinished--Text'>Si deseas iniciar tu sesión nuevamente, haz clic en el botón 'Ir a iniciar sesión'.</p>
                                <button type='button' className='Exams__SessionFinished__Buttons' onClick={GoToLogin}>Ir a iniciar sesión</button>
                            </div>

                            {/* Comentar este mensaje cuando se descomente lo de arriba */}
                            {/* <div className="Exams__SessionFinished">
                                <p className='Exams__SessionFinished--Title'>Sesión finalizada</p>
                                <p className='Exams__SessionFinished--Text'>Se ha cerrado tu sesión. Haz clic en el botón para ir a iniciar tu sesión.</p>
                                <button type='button' className='Exams__SessionFinished__Buttons' onClick={GoToLogin}>Ir a iniciar sesión</button>
                            </div> */}
                        </>
                    ) : (
                        <div className="Exams-Container">
                            <GoToBack url={'/course'} />

                            <div className='Exams-Container__Evaluation'>
                                <div className='Exams-Container-Data'>
                                    <i className="bi bi-file-earmark-spreadsheet Exams-Container-Icon"></i>
                                    <p className='Exams-Container-Title'>{translate('labels.viewer.exam.title')}</p>
                                    <p className='Exams-Container-Text'>{translate('labels.viewer.exam.block')} {blockName}</p>
                                    <p className='Exams-Container-Text'>{translate('labels.viewer.exam.name')} {examName}</p>
                                </div>
                                
                                <div className='Exams-Container-Instructions'>
                                    <div className='Exams-Container-Instructions-Subcontainer'>
                                        <p className='Exams-Container-Instructions-Top'>Inicia tu examen en 2 sencillos pasos:</p>
                                        <p className=''>1.- Instala la aplicación <span className='Exams-Container-Instructions-Highlight'>ZtudiaApp</span> en tu equipo (PC o Laptop)</p>
                                        <p className=''>2.- Haz clic en el botón <span className='Exams-Container-Instructions-Highlight'>Ir al examen</span> desde tu equipo (PC o Laptop)</p>
                                    </div>

                                    {isButtonLoading ? (
                                        <button type='button' className='Exams-Container-Buttons Exams-Container-Buttons-Disabled'>{translate('labels.viewer.exam.loadingSubmit')}</button>
                                    ) : (
                                        <button type='button' className='Exams-Container-Buttons' onClick={GoToExam}>{translate('labels.viewer.exam.submit')}</button>
                                    )}

                                    <p className='Exams-Container-Notes'>{translate('labels.viewer.exam.note')}</p>
                                </div>
                            </div>

                            <div className='Exams-Container__Message'>
                                <div className='Exams-Container-Instructions'>
                                    <div className='Exams-Container-Instructions-Subcontainer'>
                                        <p className='Exams-Container-Instructions-Top'>Inicia tu examen en 2 sencillos pasos:</p>
                                        <p className=''>1.- Instala la aplicación <span className='Exams-Container-Instructions-Highlight'>ZtudiaApp</span> en tu equipo (PC o Laptop)</p>
                                        <p className=''>2.- Haz clic en el botón <span className='Exams-Container-Instructions-Highlight'>Ir al examen</span> desde tu equipo (PC o Laptop)</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </main>
            ) : (
                <main className='container Container-FullHeight Exams'>
                    <Disabled />
                </main>
            )}
        </>
    )
}

export { Exam };